<template>
  <div class="list-item-tree-wrap">
    <span class="loading-wrap">
      <a-spin :spinning="loading" />
    </span>
    <a-input-search class="search-wrap" placeholder="回车确认检索" v-model="companyName" allowClear pressEnter @search="onSearch" />
    <a-tree
      v-if="treeData.length > 0"
      v-model="checkedKeys"
      :replaceFields="{key:'enpName'}"
      :defaultSelectedKeys="defaultCheckedKeys"
      :expandedKeys.sync="expendedKeys"
      :tree-data="treeData"
      @select="onSelect">
        <template slot="title" slot-scope="{ enpName, patentCount }">
          <span :title="enpName + `(${patentCount})`">
            <span v-if="enpName.indexOf(searchValue) > -1" >
              {{ enpName.substr(0, enpName.indexOf(searchValue)) }}
            <span style="color: #f50">{{ searchValue }}</span>
              {{ enpName.substr(enpName.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ enpName }}</span>
            <span>({{patentCount}})</span>
          </span>
        </template>
      </a-tree>
  </div>
</template>

<script>
import { getCompanyList } from '@/api/competitor'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      searchValue: '',
      companyName: '', // 企业名录的搜索
      expendedKeys: [],
      treeData: [],
      defaultCheckedKeys: [],
      // 已选企业名录检索式处理
      checkedKeys: []
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getCompanySelectedList',
      'getCompanyExp'
    ])
  },
  created() {
    this.initRequest()
    this.initSetting()
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateCompany',
      'updateCompanySelectedList',
      'clearSecondSearchExp',
      'clearFilterAndExcludeExp',
      'resetAllSetting',
    ]),
    initSetting() {
      this.defaultCheckedKeys = [...this.getCompanySelectedList]
      this.checkedKeys = [...this.getCompanySelectedList]
    },
    // 处理企业名录的检索式
    handlerCompanyExp() {
      const isAll = this.checkedKeys.length === 0
      let checkList = this.treeData
        .map(item => this.checkedKeys.includes(item.enpName) ? item.searchExpression : '')
        .filter(item => Boolean(item))
      if(isAll) { // 全部带上
        checkList = this.treeData.map(item => item.searchExpression)
      }
      const companyExp = checkList.length > 0 ? `(${checkList.join(' or ')})` : ''
      this.updateCompany(companyExp)
    },
    // 侧边栏选中的item
    onSelect(checkedKeys) {
      this.checkedKeys = checkedKeys
      this.clearSecondSearchExp()
      this.clearFilterAndExcludeExp() // 清空过滤的检索式
      this.resetAllSetting()  // 清空筛选的勾选配置
      this.handlerCompanyExp()  // 更新检索式
      this.updateCompanySelectedList(checkedKeys)  // 更新企业名录已选
    },
    // 获取过滤的key
    filterExpandedKeys(searchValue, list) {
      let expandedKeys = []
      list.forEach((item) => {
        const isFind = item.enpName.indexOf(searchValue) > -1
        if (isFind) {
          // !! 当前仅支持，一层节点。
          expandedKeys.push(item.parentKey || item.enpName)
        } else if (item.children) { // 如果当前节点还有子节点。则递归子节点查询对应的名称
          const keys = this.filterExpandedKeys(searchValue, item.children)
          expandedKeys = expandedKeys.concat(keys)
        }
      })
      return expandedKeys
    },
    // 搜索侧边栏的筛选
    onSearch(searchValue) {
      const expendedKeys = this.filterExpandedKeys(searchValue, this.treeData)
      Object.assign(this, {
        searchValue,
        expendedKeys
      })
      this.initRequest()
    },
    async initRequest() {
      this.loading = true
      const title = this.companyName
      const { data } = await getCompanyList(title)
      this.loading = false
      this.treeData = data.competitorLibraryManages
      this.handlerCompanyExp()  // 处理企业名录的检索式
    }
  }
}
</script>
